import React, { useEffect } from 'react'
import TokenGlyph from './TokenGlyph'
import './HowToPlay.css'

const EXAMPLES = [
  { letters: ['À', 'B', 'Ú', 'R', 'Ò'], states: ['correct', null, null, null, null], note: 'À is in the word and in the right spot.' },
  { letters: ['Ì', 'Y', 'À', 'W', 'Ó'], states: [null, null, 'present', null, null], note: 'À is in the word but in the wrong spot.' },
  { letters: ['O', 'R', 'Ú', 'K', 'Ọ'], states: [null, null, null, null, 'absent'], note: 'Ọ is not in the word at all.' },
]

const ExampleRow = ({ letters, states, note }) => (
  <div className="htp-example">
    <div className="htp-example__row">
      {letters.map((l, i) => (
        <div key={i} className={`htp-tile ${states[i] ? `htp-tile--${states[i]}` : ''}`}>
          <TokenGlyph token={l} />
        </div>
      ))}
    </div>
    <p className="htp-example__note">{note}</p>
  </div>
)

const HowToPlay = ({ onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="htp-backdrop" onClick={onClose}>
      <div className="htp-modal" onClick={e => e.stopPropagation()}>
        <button className="htp-close" onClick={onClose} aria-label="Close">✕</button>

        <h2 className="htp-title">How to play</h2>
        <p className="htp-lead">Guess the Yorùbá word in 6 tries. Each guess must fill all the letter tiles.</p>

        <h3 className="htp-section">Colour feedback</h3>
        {EXAMPLES.map((ex, i) => <ExampleRow key={i} {...ex} />)}

        <h3 className="htp-section">Yorùbá keys</h3>
        <p className="htp-body">The keyboard includes characters unique to Yorùbá:</p>
        <ul className="htp-list">
          <li><strong>ẹ / ọ</strong> — open-mid vowels (distinct from e / o)</li>
          <li><strong>ṣ</strong> — the "sh" sound</li>
          <li><strong>gb</strong> — a single labial-velar consonant, counts as one letter</li>
        </ul>

        <h3 className="htp-section">Coming soon — Tone phase</h3>
        <p className="htp-body">
          Once you solve the letters, a second round unlocks: place the correct
          tone marks (à / á / a) on each vowel. Yorùbá is a tonal language —
          the same letters can mean completely different things with different tones.
        </p>

        <button className="htp-start" onClick={onClose}>Got it, let's play</button>
      </div>
    </div>
  )
}

export default HowToPlay
